/**
 * Asset Keyboard Shortcuts Configuration
 *
 * This file contains keyboard shortcut mappings for asset management actions.
 * These shortcuts enable quick status changes for selected assets.
 */

import { AssetStatus } from '@/types';

/**
 * Keyboard action configuration for asset status changes
 */
export const KEYBOARD_ACTIONS = {
  /** Alt+F - Freeze asset */
  KeyF: {
    status: AssetStatus.Frozen,
    label: 'Freeze',
    description: 'Freeze selected assets',
  },
  /** Alt+U - Unfreeze/Activate asset */
  KeyU: {
    status: AssetStatus.Active,
    label: 'Unfreeze',
    description: 'Activate selected assets',
  },
  /** Alt+D - Delete asset */
  KeyD: {
    status: AssetStatus.Deleted,
    label: 'Delete',
    description: 'Delete selected assets',
  },
} as const;

/**
 * Helper function to get status from keyboard code
 *
 * @param code - Keyboard code (e.g., 'KeyF', 'KeyU', 'KeyD')
 * @returns AssetStatus if code is valid, undefined otherwise
 */
export const getStatusFromKeyboardCode = (
  code: string
): AssetStatus | undefined => {
  const action = KEYBOARD_ACTIONS[code as keyof typeof KEYBOARD_ACTIONS];
  return action?.status;
};
